module.exports = __webpack_public_path__ + "static/img/n-function.f7a0dffc.png";